import { Body, Field, FieldLabel } from '@e2n/ui/v2';
import { useId } from 'react';
import { useTranslation } from 'react-i18next';
import type { AbgleichZeile } from '../../../hooks/useMitarbeiterabgleich/entities/Mitarbeiterabgleich';
import { mitarbeiterName } from './mitarbeiterName';
import { StandortSelect } from './StandortSelect';

export function FuerAlleZuordnung({
  zeilen,
  standorte,
  standort,
  onStandortChange,
}: {
  zeilen: AbgleichZeile[];
  standorte: string[];
  standort?: string;
  onStandortChange: (standort: string) => void;
}) {
  const { t, i18n } = useTranslation();
  const selectId = useId();
  const namen = new Intl.ListFormat(i18n.language, {
    type: 'conjunction',
  }).format(zeilen.map(mitarbeiterName));

  return (
    <div className="flex flex-col gap-4">
      <Field className="w-1/2">
        <FieldLabel htmlFor={selectId}>
          {t('domain.datev.abgleich.spalten.standort')}
        </FieldLabel>
        <StandortSelect
          id={selectId}
          value={standort}
          standorte={standorte}
          onChange={onStandortChange}
        />
      </Field>
      <Body size="sm" className="text-labels-secondary">
        {t('domain.datev.abgleich.zuordnung.hinweis', {
          count: zeilen.length,
          namen,
        })}
      </Body>
    </div>
  );
}
